import React from 'react';

const PropertyDetail = ({ details }) => (
	<div>
		<div className="property-detail-info-list section-bg-1 clearfix mb-60">
			{details?.map((detailGroup, index) => (
				<ul key={index}>
					{detailGroup?.map((detail, idx) => (
						<li key={idx}><label>{detail?.label}:</label> <span>{detail?.value}</span></li>
					))}
				</ul>
			))}
		</div>
	</div>
);

export default PropertyDetail;